import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { watchdogAuthGuard } from './watchdog-dashboard/watchdog-auth.guard'

const routes: Routes = [
  {
    path: 'watchdog-dashboard',
    canActivate: [watchdogAuthGuard],
    loadChildren: () =>
      import('./watchdog-dashboard/watchdog-dashboard.routes').then(
        module => module.WATCHDOG_DASHBOARD_ROUTES
      ),
  },
  {
    path: 'speedbox',
    loadChildren: () =>
      import('./backoffice/backoffice.module').then(m => m.BackofficeModule),
  },

  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule),
  },

  { path: '', redirectTo: 'auth', pathMatch: 'full' },
]

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
